import { SelectItemAdapter } from './ui';

export const toRemIfUnspecified = (s?: number | string | null): string => typeof s === 'number'
    ? toRemIfUnspecified(s.toString())
    : (!!s ? s.split(' ').filter(x => !!x).map(x => x.match(/\d+[A-Za-z]+/) ? x : x + 'rem').join(' ') : 'initial');

export type IdLabelPair = { readonly id: string, readonly label: string };
export const IdLabelAdapter = <T extends IdLabelPair>(): SelectItemAdapter<T> => ({
    key: item => item.id,
    label: item => item.label,
});

export const ellipsisAfter = (num: number, str: string) =>
    str.length > num ? str.slice(0, num).concat('…') : str;
